import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { getBackHomeUrl } from '../common/homeUrlByHost.js';

class ErrorPage extends Component {
    render() {
        const { t } = this.props;
        const homeUrl = getBackHomeUrl();
        return (
            <div id="content">
                <Helmet>
					<title>Error</title>
                    <meta name="robots" content="noindex,nofollow" />
				</Helmet>
                <div className="page-error">
                    <div className="container text-center">
                    <img src={require('../assets/images/404.png').default} alt="Hát karaoke vui nhộn" />
                        {/* <h2 className="heading">{t("error_page.title", "Error 500")}</h2> */}
                        <h2 className="heading">Error 500</h2>
                        <a href={homeUrl} className="btn-yellow">
                            <i className="fa fa-angle-left" /> {t("not_found_page.back_home", "Quay về trang chủ")}
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(ErrorPage)